import React from "react";
import * as c from "./paymentsRateSection.module.scss";
import classNames from "classnames";
import checkIcon from "@images/payments/check.svg";
import { Button } from "@components/shared";

const features = [
  "Straightforward rates",
  "Quick & easy sign up",
  "Accept all major credit cards",
  "Safe & secure card-on-file",
  "No-show protection",
  "Automated membership billing",
  "Support for booth renter setup",
  "Client self-checkout",
  "Compact card reader available",
];

const rateCards = [
  {
    type: "IN-PERSON PAYMENTS",
    rate: "2.45%",
    plus: "+ 15¢",
    description: "per successful transaction",
  },
  {
    type: "VIRTUAL PAYMENTS",
    rate: "2.90%",
    plus: "+ 20¢",
    description: "per successful transaction",
  },
];

const PaymentsRateSection = () => {
  return (
    <section className={c.container} data-transition="slide-enter">
      <h2 className={classNames(c.heading, "h2")}>Simple, straightforward rates</h2>

      <div className={c.rateSection}>
        {rateCards.map((card, index) => (
          <div key={index} className={c.rateCard}>
            <p className={classNames(c.label, "eyebrow")}>{card.type}</p>
            <p className={classNames(c.rate, "h1")}>
              {card.rate}
              <span>{card.plus}</span>
            </p>
            <p className={classNames(c.description, "p3")}>{card.description}</p>
          </div>
        ))}
      </div>

      <ul className={c.rateList}>
        {features.map((feature, index) => (
          <li key={index} className={classNames(c.listItem, "p3")}>
            <img src={checkIcon} alt="" />
            {feature}
          </li>
        ))}
      </ul>

      <div className={c.infoSection}>
        <h6 className={classNames(c.title, "h6")}>Custom rates are available</h6>
        <p className={classNames(c.info, "p3")}>
          Some businesses qualify for custom rate options including interchange plus pricing.{" "}
          <Button
            asHtmlButton
            variant="textgradient"
            onClick={(e) => {
              e.preventDefault();
              drift && drift.api.openChat();
            }}
          >
            Start a chat
          </Button>
          &nbsp;to learn more about eligibility.
        </p>
      </div>
    </section>
  );
};

export default PaymentsRateSection;
